<template>
  <div v-if="enable || notice">
    <ActionButton v-if="enable" :label="t('button-enable-notify')" :action="enableNotify" variant="link" :collect="true" :fallback="false" class="enable-notify" />
    <WeChatNotifyNotice v-if="notice" @close="closed = true" />
  </div>
</template>
<script>
import ActionButton from '@/components/ActionButton';
import WeChatNotifyNotice from './WeChatNotifyNotice';
import { settings, insideWeChat } from './wechat';
import { t } from '@/texts';
export default {
  props: { state: Object, waiting: Boolean },
  components: { ActionButton, WeChatNotifyNotice },
  data: () => ({ closed: false }),
  computed: {
    user() { return this.$store.state.user; },
    eligible() { return this.waiting && insideWeChat() && !!settings.notifyTemplateId && !!this.user && this.state.possible; },
    enable() { return this.eligible && !!this.user.notifyAsked && this.user.notify !== false && !this.state.ready; },
    // A player who hasn't answered the reminder notice gets it once, while waiting for the opponent.
    notice() { return this.eligible && !this.user.notifyAsked && !this.closed; },
  },
  methods: { t, enableNotify() { /* The tap's native popup does the work. */ } },
};
</script>
<style scoped>
.enable-notify { display: block; margin: 8px auto; max-width: 300px; }
</style>
